const component = "program-form-dialog";

export const programFormDialog = {
  component,
  slider: `${component}/range-slider`,
  startTime: {
    label: `${component}/start-time/label`,
    datePicker: `${component}/start-time/date-picker`,
    error: `${component}/start-time/error-text`,
  },
  endTime: {
    label: `${component}/end-time/label`,
    datePicker: `${component}/end-time/date-picker`,
    error: `${component}/end-time/error-text`,
  },
  modeItem: `${component}/mode-item`,
  modeError: `${component}/mode-error-text`,
  temperature: {
    label: `${component}/temperature/label`,
    input: `${component}/temperature/input`,
  },
  applyOnBusinessDays: {
    label: `${component}/apply-on-business-days/label`,
    checkbox: `${component}/apply-on-business-days/checkbox`,
  },
  applyOnWeekend: {
    label: `${component}/apply-on-weekend/label`,
    checkbox: `${component}/apply-on-weekend/checkbox`,
  },
  cancelBtn: `${component}/cancel-button`,
  submitBtn: `${component}/submit-button`,
};
